import React from "react"
import { Box } from "@material-ui/core"
import { Header } from "./Header"

export const Layout: React.FC = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" height={1}>
      <Header />
      <Box
        flexGrow={1}
        display="flex"
        position="relative"
        style={{ overflowX: "hidden", overflowY: "auto" }}
      >
        {children}
      </Box>
    </Box>
  )
}
